module.exports = __webpack_public_path__ + "img/img1.f58c7a33.jpg";